import { FILE_ROOT,pathLoac } from "@config";
import dayjs from "dayjs";
import CryptoJS from 'crypto-js'
/**
 * 图片地址格式化
 * @param {string} rawImg 图片地址
 * @returns {string}
 */
export function formatImg(rawImg) {
  if (!rawImg) return "";
  return FILE_ROOT + rawImg;
}

/**
 * 日期时间格式化
 * @param {date} dateTime
 * @param {string} forma
 * @returns {string}
 */
export function formatTime(dateTime, forma = "YYYY-MM-DD HH:mm") {
  if (!dateTime || dateTime <= 0) return "-";
  return dayjs(dateTime).format(forma);
}

// 时间转时间戳
export function convertToTimestamp(dateInput) {
  // 如果输入是一个有效的 Date 对象，直接获取时间戳
  if (dateInput instanceof Date) {
    return dateInput.getTime();
  }

  // 如果输入是字符串，尝试将其转换为 Date 对象
  const date = new Date(dateInput);

  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    throw new Error('无效的日期格式');
  }

  return date.getTime();
}

/**
 * 获取两个日期之间的持续时间
 * @param {date} startTime
 * @param {date} endTime
 * @param {string} type (years、months、days、hours、minutes、seconds)
 * @returns {number}
 */
export function dateDiff(startTime, endTime, type = "days") {
  if (!startTime || !endTime) return 0;
  const diffNumber = dayjs(startTime).diff(endTime, type);
  return Math.abs(diffNumber);
}

/**
 * 生成字母选项（ABCD...）
 * @param {number} num 数字从0开始
 */
export function creationLetter(num = 0) {
  const ascii = num + 65;

  if (!isNaN(num) && ascii < 65 && ascii >= 91) return "-";
  return String.fromCharCode(ascii);
}

/**
 * 获取地址栏中的参数
 * 一般用于第三方登录（微信登录、QQ登录等）
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * 元素类切换开关
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * 数组去重
 * 可以弃用，直接使用lodash中的去重方法
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * 生成一个无重复的字符串
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * 检查一个元素是否有一个类
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * 向元素添加类
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * 从元素中移除类
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}


/***
 * 跳转页面, 并携带参数,vue内部跳转
 * @param {string} url 跳转地址
 * @param {Object} params 参数
 * @returns {void}
 * ****/
export function navigate(url, params = null, _blank = true) {
  let str = "/cn";
  let Language = localStorage.getItem("currentLanguage"); //获取本地语言

  // 判断语言
  if (Language && Language != "zh") {
    str = "/" + Language;
  }
  let target;

  // 判断是否有参数
  if (params != null) {
    target = this.$router.resolve(
      str + url + '/' + params
    );
  }else{
    target = this.$router.resolve(
      str + url
    );
  }
  if(_blank){
    window.open(target.href, "_blank");
  }else{
    window.location.href = target.href;
  }
  //
}
/***
 * 跳转页面, 并携带参数,vue内部跳转
 * params为若干参数
 * @param {string} url 跳转地址
 * @param {Object} params 参数
 * @param {boolean} _blank 是否在新窗口打开
 * @returns {void}
 * ****/
export function navigateParams(url, params = null, _blank = true) {
  let str = "/cn";
  let Language = localStorage.getItem("currentLanguage"); // 获取本地语言
  if (Language && Language!== "zh") {
    str = "/" + Language;
  }

  let fullUrl = str + url;

  if (params && typeof params === 'object') {
    const { id, ...otherParams } = params;
    if (id!== undefined) {
      fullUrl += `/${id}`;
    }
    const queryParams = [];
    for (const key in otherParams) {
      if (otherParams.hasOwnProperty(key)) {
        const value = encodeURIComponent(otherParams[key]);
        queryParams.push(`${key}=${value}`);
      }
    }
    if (queryParams.length > 0) {
      fullUrl += `?${queryParams.join('&')}`;
    }
  }

  const target = this.$router? this.$router.resolve(fullUrl) : { href: fullUrl };

  if (_blank) {
    window.open(target.href, "_blank");
  } else {
    window.location.href = target.href;
  }
}

/***
 * 1.0版本外部跳转
 * ****/ 
export function externalTo(url, params = null, _blank = true) {
  let str = "/protal";

      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = "/protal_" + Language;
      } else {
      }
      let urls;
      if(params){
        urls = pathLoac + str + url + '/' + params; 
      }else{
        urls = pathLoac + str + url; 
      }
      if(_blank){
        window.open(urls, "_blank"); 
      }else{
        window.location.href = urls;
      }
      // const urls = pathLoac + str + url; // 你想要跳转的 URL
      // const url = pathLoac + str + '/search/index/search_key/' + this.form.search; // 你想要跳转的 URL
      //
}


/**
 * 跳转外部地址
 * @param {string} url 跳转地址
 * @param {boolean} _blank 是否在新窗口打开
 * @param {string} target 目标窗口
 * @param {string} params 参数
 * @param {string} callback 回调地址
 * *****/  
export function jumpLink(url,target=false){
  if(!url)return false;
  if(target==true){
    window.open(url);
  }else{
    window.location.href=url;
  }
}


/** 驻站专家报名等场景：登录回跳固定路径（避免 401 与 router 竞态导致 callback 不是申请页） */
const STATIONED_APPLY_LOGIN_KEY = "oceanclub_stationed_apply_login_redirect";

/**
 * 写入「登录/完善资料成功后」要回到的前端路径（含 5 分钟 TTL）
 * @param {string} path 如 /cn/stationed/application
 */
export function setStationedApplyLoginRedirect(path, ttlMs = 300000) {
  if (!path) return;
  try {
    localStorage.setItem(
      STATIONED_APPLY_LOGIN_KEY,
      JSON.stringify({ path, exp: Date.now() + ttlMs })
    );
  } catch (e) {
    /* ignore */
  }
}

/** 取消驻站申请登录回跳（已登录且接口成功时调用，避免残留） */
export function clearStationedApplyLoginRedirect() {
  try {
    localStorage.removeItem(STATIONED_APPLY_LOGIN_KEY);
  } catch (e) {
    /* ignore */
  }
}

/**
 * 取出并清除驻站申请登录回跳路径；过期或格式错误返回 null
 * @returns {string|null}
 */
export function consumeStationedApplyLoginRedirect() {
  let raw;
  try {
    raw = localStorage.getItem(STATIONED_APPLY_LOGIN_KEY);
  } catch (e) {
    return null;
  }
  if (!raw) return null;
  try {
    localStorage.removeItem(STATIONED_APPLY_LOGIN_KEY);
    const o = JSON.parse(raw);
    if (o && o.path && o.exp && o.exp > Date.now()) {
      return String(o.path);
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

/** 通用登录/完善资料回跳（话题投稿、活动等），优先级低于驻站申请 */
const POST_LOGIN_REDIRECT_KEY = "oceanclub_post_login_redirect";

export function setPostLoginRedirect(path, ttlMs = 300000) {
  if (!path) return;
  try {
    localStorage.setItem(
      POST_LOGIN_REDIRECT_KEY,
      JSON.stringify({ path, exp: Date.now() + ttlMs })
    );
  } catch (e) {
    /* ignore */
  }
}

export function clearPostLoginRedirect() {
  try {
    localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  } catch (e) {
    /* ignore */
  }
}

export function consumePostLoginRedirect() {
  let raw;
  try {
    raw = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  } catch (e) {
    return null;
  }
  if (!raw) return null;
  try {
    localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
    const o = JSON.parse(raw);
    if (o && o.path && o.exp && o.exp > Date.now()) {
      return String(o.path);
    }
  } catch (e) {
    /* ignore */
  }
  return null;
}

// 跳转登录页
export function jumpLogin(target = false, need_callback = true, customCallback = null) {
  let str = "/cn";

  let Language = localStorage.getItem("currentLanguage"); //获取本地语言
  if (Language && Language != "zh") {
    str = "/" + Language;
  } else {
  }

  let url;
  if (need_callback == true) {
    let path =
      consumeStationedApplyLoginRedirect() ||
      consumePostLoginRedirect() ||
      customCallback ||
      (() => {
        const parsedUrl = new URL(window.location.href);
        return parsedUrl.pathname + (parsedUrl.search || "");
      })();
    url = str + "/login?callback=" + encodeURIComponent(path);
  } else {
    url = str + "/login";
  }

  if (target == true) {
    console.log("new-window", "----------");

    window.open(url);
  } else {
    console.log("this-window", "----------");
    window.location.href = url;
  }
}

//AES加密
export function encryptByAES(str, key, iv) {
  key+='caaEE209d5';
  iv+='HesysWpM';
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  var encrypted = CryptoJS.AES.encrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}

//AES解密
export function decryptByAES(ciphertext, key, iv) {
  key+='caaEE209d5';
  iv+='HesysWpM';
  key = CryptoJS.enc.Utf8.parse(key);
  iv = CryptoJS.enc.Utf8.parse(iv);
  var decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

//DES加密
export function encryptByDES(string, key, ivstr) {
  let KeyHex = CryptoJS.enc.Utf8.parse(key);
  let encrypted = CryptoJS.DES.encrypt(string,
    KeyHex, {
    mode: CryptoJS.mode.CBC,  // ecb模式不需要偏移量
    padding: CryptoJS.pad.Pkcs7,
    iv: CryptoJS.enc.Utf8.parse(ivstr)
  });

  return encrypted.toString(); //此方式返回base64格式密文
  // return encrypted.ciphertext.toString() // 返回hex格式的密文
}

//DES解密
export function decryptByDES(ciphertext, key, ivstr) {
  let keyHex = CryptoJS.enc.Utf8.parse(key);
  let decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Hex.parse(ciphertext)
  }, keyHex, {
    iv: CryptoJS.enc.Utf8.parse(ivstr),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}



export function erroravatarHandler(){
  return true
}


/**
 * 手机号脱敏
 * **/ 
export function validTelHide(tel) {
  return tel.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2"); 
}

/***
 * 邮箱脱敏  validEmail 这个名字重复了
 * **/

export function validEmailHide(email) {
  return email.replace(/^([a-zA-Z0-9_]{3})[a-zA-Z0-9_.\-]+@([a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)$/, "$1****@$2");
  // return email.replace(/^(.{3}).+@(.+)$/, "$1****@$2");
  // return email.replace(/^(\w{3})[\w-]+@\w+(\.\w+){1,2}$/, "$1****@$2"); 
}